import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  {
    name: 'owners',
    label: 'Choose Borrower',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'type',
    label: 'Asset Type',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'financialInstitution',
    label: 'Depositor Institution',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'accountNumber',
    label: 'Account Number',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'gifterName',
    label: 'Gifter Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'sourceOfFunds',
    label: 'Source Of Funds',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'relationship',
    label: 'Relationship',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'closingCosts',
    label: 'Closing Costs',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'downPayment',
    label: 'Down Payment',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'isDeposited',
    label: 'Is deposited?',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'giftFundsProvisionPeriod',
    label: 'When will gift funds be provided?',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'grantSourceName',
    label: 'Source Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'sourceType',
    label: 'Source',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'otherSourceOfGrantDescription',
    label: 'Other Source Description',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'cashOrMarketValue',
    label: 'Balance / Amount / Total Amount',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'closingCosts',
    label: 'Closing Costs',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'downPayment',
    label: 'Down Payment',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'isUsedForDownPayment',
    label: 'Use asset for down payment',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'isUsedForIncome',
    label: 'Use asset for income',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'includeInAssets',
    label: 'Include In Assets',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const assetsForm = {
  name: FormNames.ASSETS,
  label: 'Assets',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
